import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Gatsby reset the scroll position on every page load. React Router keeps it,
// which lands you mid-page after a navigation, so restore the old behaviour.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
